// API client for Il Pescematto (web). Uses REACT_APP_BACKEND_URL.
const API_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "auth.token";

export function getToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || null;
  } catch {
    return null;
  }
}

export function setToken(token) {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearToken() {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

export class ApiError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

async function request(path, init = {}, { auth = false } = {}) {
  const headers = new Headers(init.headers);
  if (init.body) headers.set("Content-Type", "application/json");
  if (auth) {
    const token = getToken();
    if (token) headers.set("Authorization", `Bearer ${token}`);
  }
  const res = await fetch(`${API_URL}${path}`, { ...init, headers });
  if (!res.ok) {
    let detail = "";
    try {
      const j = await res.json();
      detail = j?.detail ?? "";
    } catch {
      /* ignore */
    }
    throw new ApiError(res.status, detail || `HTTP ${res.status}`);
  }
  if (res.status === 204) return undefined;
  return res.json();
}

// ---------- Auth ----------
export async function loginApi(username, password) {
  const data = await request("/api/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
  setToken(data.access_token);
  return data;
}

export async function logoutApi() {
  clearToken();
}

export function isAuthenticated() {
  return !!getToken();
}

// ---------- Settings ----------
export async function fetchPhone() {
  const data = await request("/api/settings/phone");
  return data.phone ?? null;
}

export async function savePhone(phone) {
  const data = await request(
    "/api/settings/phone",
    { method: "PUT", body: JSON.stringify({ phone }) },
    { auth: true },
  );
  return data.phone;
}

export async function fetchMenu() {
  const data = await request("/api/settings/menu");
  return data.menu ?? null;
}

export async function saveMenu(menu) {
  const data = await request(
    "/api/settings/menu",
    { method: "PUT", body: JSON.stringify({ menu }) },
    { auth: true },
  );
  return data.menu;
}

export async function resetMenuApi() {
  await request("/api/settings/menu", { method: "DELETE" }, { auth: true });
}
